const bmiData = [
    {
        id: 1,
        name: "وزن",
        unit: "کیلوگرم"
    },
    {
        id: 2,
        name: "قد",
        unit: "سانتی متر"
    }
]

export default bmiData